import React from 'react';
import { logExploreCommunityContentClicked, logExploreCuratedTrailsClicked } from '@alltrails/analytics/amplitudeFunctions';
import { PageStrings } from '@alltrails/shared/utils/pageStringHelpers';
import classNames from 'classnames';
import { StringConstantsMixin } from 'react_components/mixins/shared/string_constants_mixin';
import * as styles from './styles/styles.module.scss';

export type Props = {
  activeItemKey: string;
  loading: unknown;
  onClick: (pageKey: string) => void;
  resultCount: number;
};

type Tab = {
  inactiveString: string;
  activeString: string;
  itemKey: string;
  analyticsHandler: () => void;
};

const ExploreTabBar = ({ activeItemKey, loading, onClick, resultCount }: Props) => {
  if (![PageStrings.EXPLORE_ALL_PAGE, PageStrings.EXPLORE_COMMUNITY_CONTENT_PAGE].includes(activeItemKey)) {
    return null;
  }

  let derivedResultCount: number | string = resultCount;
  if (resultCount >= 1000) {
    derivedResultCount = StringConstantsMixin.strings.SEARCH.MAX_NUM_RESULTS;
  }

  const tabs: Tab[] = [
    {
      inactiveString: StringConstantsMixin.strings.SEARCH.CURATED_TRAILS,
      activeString: `${StringConstantsMixin.strings.SEARCH.CURATED_TRAILS} (${derivedResultCount})`,
      itemKey: PageStrings.EXPLORE_ALL_PAGE,
      analyticsHandler: logExploreCuratedTrailsClicked
    },
    {
      inactiveString: StringConstantsMixin.strings.SEARCH.COMMUNITY_CONTENT,
      activeString: `${StringConstantsMixin.strings.SEARCH.COMMUNITY_CONTENT} (${derivedResultCount})`,
      itemKey: PageStrings.EXPLORE_COMMUNITY_CONTENT_PAGE,
      analyticsHandler: logExploreCommunityContentClicked
    }
  ];

  const action = (item: Tab) => () => {
    item.analyticsHandler();

    _gaq.push(['_trackEvent', 'Explore Tab Change', item.itemKey]);

    onClick(item.itemKey);
  };

  return (
    <div className={classNames(styles.tabBar, styles.explore)}>
      {tabs.map(item => {
        const { inactiveString, activeString, itemKey } = item;
        const isActive = itemKey === activeItemKey;

        return (
          <div
            key={item.itemKey}
            tabIndex={0}
            role="tab"
            className={classNames(styles.tab, styles.explore, { [styles.active]: isActive })}
            onClick={action(item)}
            onKeyDown={action(item)}
          >
            {isActive && !loading ? activeString : inactiveString}
          </div>
        );
      })}
    </div>
  );
};

export default ExploreTabBar;
